
export const getMaritalStatus = ()=>([
  {id: 0, title: "Single"},
  {id: 1, title: "Married"},
  {id: 2, title: "Seperated"},
  {id: 3, title: "Divorced"}
])
